import MicroModal from 'micromodal';
import Flickity from "flickity";
import 'flickity-imagesloaded';

function Gallery() {
    var elem = document.querySelector('.main-carousel');
    var flkty = new Flickity( elem, {
    cellAlign: 'left',
    imagesLoaded: true,
    contain: true,
    wrapAround: true,
    lazyLoad: 1,
    });

    var flkty = new Flickity( '.main-carousel', {

    });

    var buttonGroup = document.querySelectorAll('.gallery-image');

    buttonGroup.forEach((button) => {
      button.addEventListener( 'click', function( event ) {
        // filter for button clicks
        if ( !event.target.matches('.image-link') ) {
          return;
        }
        var selector = event.target.getAttribute('data-selector');
        flkty.selectCell( selector );
      });
    });

    try {
        MicroModal.init({
          awaitCloseAnimation: true, 
          onShow: function (modal) {
            addModalContentHeight("short");
          },
        });
      } catch (e) {
        console.log("micromodal error: ", e);
      }

      function addModalContentHeight(type) {
        var modalContent = $(".modal__content");
              modalContent.css({ height: 100 + "%" });
              flkty.resize();
      }
}

export default Gallery;


// WEBPACK FOOTER //
// ./js/components/gallery/gallery.js